import { DatePicker, Empty, Form, Spin, Table } from "antd";
import React from "react";
import { useState } from "react";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calendar-icon.svg";
import { getRequest } from "../../../http/axiosConfig/config";
import urls from "../../../http/endpoints/urls";
import DownloadReport from "./DownloadReport";

export default function OnlineTransaction() {
  let customerId = localStorage.getItem("userId");
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState(null);
  const [dateForm] = Form.useForm();

  const getTranasctions = async (values) => {
    try {
      setLoading(true);
      let formattedFormDate = values.fromDate.format("DD-MMM-YY");
      let formattedToDate = values.toDate.format("DD-MMM-YY");

      const res = await getRequest(
        urls.onlineTransactions(customerId, formattedFormDate, formattedToDate)
      );
      setTransactions(res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const onlineTransactionsColumns = [
    { title: "Date", dataIndex: "CREATED_DATE", width: 100 },
    {
      title: "Amount",
      dataIndex: "AMOUNT",
      width: 80,
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "STATUS",
      width: 100,
      align: "center",
    },
    {
      title: "Order Id",
      dataIndex: "ORDER_ID",
      width: 150,
      align: "center",
    },
    {
      title: "Tracking Id",
      dataIndex: "TRACKING_ID",
      width: 150,
      align: "center",
      render: (val) => (val ? val : "--"),
    },
    {
      title: "Bank ref no",
      dataIndex: "BANK_REF_NO",
      width: 150,
      align: "center",
      render: (val) => (val ? val : "--"),
    },
  ];

  return (
    <div>
      <div className="page-header">
        Online Transactions
        {/* {transactions && transactions.length && !loading ? (
          <DownloadReport
            columns={onlineTransactionsColumns}
            data={transactions}
            reportName="Online Transactions"
            to={dateForm.getFieldValue("toDate").format("DD/MM/YY")}
            from={dateForm.getFieldValue("fromDate").format("DD/MM/YY")}
          />
        ) : null} */}
      </div>
      <Form
        className="date-range-form"
        form={dateForm}
        layout={"horizontal"}
        onFinish={getTranasctions}
        requiredMark={false}
        style={{ marginTop: 10, marginBottom: 10 }}
      >
        <Form.Item
          noStyle
          name={"fromDate"}
          rules={[{ required: true, message: "Please select from date" }]}
        >
          <DatePicker suffixIcon={<CalendarIcon />} format="DD/MM/YY" />
        </Form.Item>
        To
        <Form.Item
          noStyle
          name={"toDate"}
          rules={[{ required: true, message: "Please select to date" }]}
        >
          <DatePicker suffixIcon={<CalendarIcon />} format="DD/MM/YY" />
        </Form.Item>
        <Form.Item noStyle>
          <button
            className="primary-btn"
            style={{
              width: 60,
              padding: 5,
              boxShadow: "none",
              borderRadius: "none",
            }}
            onClick={() => dateForm.submit()}
          >
            Go
          </button>
        </Form.Item>
      </Form>

      {!loading && transactions ? (
        <Table
          dataSource={loading ? [] : transactions}
          locale={{
            emptyText: loading ? <Spin /> : <Empty />,
          }}
          columns={onlineTransactionsColumns}
          bordered
          scroll={{ y: "calc(100vh - 396px)", x: 200 }}
          pagination={false}
        />
      ) : null}
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : null}
    </div>
  );
}
